<template>
  <v-container
    id="dashboard"
    fluid
    tag="section"
  >
    <v-row>
      <v-col>
        <v-progress-linear
          :active="loading"
          :indeterminate="loading"
          absolute
          color="primary"
        />
      </v-col>
    </v-row>
    <sequential-entrance from-top>
      <v-row>
        <v-col
          sm="12"
          md="12"
          lg="12"
        >
          <base-material-card
            v-if="!loading"
            color="primary"
            icon="mdi-map-marker-radius"
            inline
          >
            <template v-slot:after-heading>
              <div class="display-2 font-weight-light">
                Invoice Reports - Days in {{ month }} - {{ daysinmonth }} days total<v-spacer />
              </div>
              <div class="display-2 font-weight-light">
                Total Active Units {{ getdaysactive.length }}<v-spacer />
              </div>
            </template>
            <v-row>
              <v-spacer />

              <download-csv
                :name="csvfilename()"
                :data="getdaysactive"
              >
                <v-btn color="info">
                  <v-icon
                    color="white"
                    left
                  >
                    mdi-arrow-down
                  </v-icon>CSV
                </v-btn>
              </download-csv>
              <v-btn
                color="warning"
                to="/"
              >
                Return
              </v-btn>
            </v-row>
            <v-row>
              <v-col cols="6">
                <v-dialog
                  ref="dialog"
                  v-model="modal"
                  :return-value.sync="date"
                  persistent
                  width="290px"
                >
                  <template v-slot:activator="{ on, attrs }">
                    <v-text-field
                      v-model="date"
                      label="Invoice for Month / Year"
                      prepend-icon="mdi-clock"
                      readonly
                      v-bind="attrs"
                      v-on="on"
                    />
                  </template>
                  <v-date-picker
                    v-model="date"
                    type="month"
                    scrollable
                  >
                    <v-spacer />
                    <v-btn
                      text
                      color="primary"
                      @click="modal = false"
                    >
                      Cancel
                    </v-btn>
                    <v-btn
                      text
                      color="primary"
                      @click="setmonth($refs.dialog.save(date))"
                    >
                      OK
                    </v-btn>
                  </v-date-picker>
                </v-dialog>
              </v-col>
              <v-col cols="6">
                <v-text-field
                  v-model="search"
                  append-icon="mdi-magnify"
                  label="Search"
                  single-line
                  hide-details
                />
              </v-col>
            </v-row>

            <v-spacer />
            <v-data-table
              :headers="locationHeaders"
              :items="getdaysactive"
              :items-per-page="50"
              :loading="reload"
              sort-by="sitename"
              :search="search"
            >
              <template v-slot:[`item.invoice`]="{ item }">
                <v-btn
                  fab
                  small
                  color="deep-purple darken-1"
                  dark
                  @click="generatepdf(item)"
                >
                  <v-icon dark>
                    mdi-pdf-box
                  </v-icon>
                </v-btn>
              </template>
            </v-data-table>
          </base-material-card>
        </v-col>
      </v-row>
    </sequential-entrance>
  </v-container>
</template>

<script>
  import moment from 'moment'
  import { jsPDF } from 'jspdf'
  import autoTable from 'jspdf-autotable'
  import imageToBase64 from 'image-to-base64/browser'

  var numeral = require('numeral')

  // const imageToBase64 = require('image-to-base64')

  export default {

    name: 'Locations',

    data () {
      return {
        search: '',
        modal: false,
        reload: false,
        date: new Date().toISOString().substr(0, 7),
        currentactives: [],
        loading: false,
        totalcount: 0,
        locations: [],
        daysinmonth: moment().daysInMonth(),
        month: moment(Date.now()).format('MMMM'),
        locationHeaders: [
          { sortable: true, text: 'Site ID', value: 'sitename', align: 'left', width: 125 },
          { sortable: false, text: 'Safe ID', value: 'safeid', align: 'center' },
          { sortable: false, text: 'Safe Type', value: 'safetype', align: 'center' },
          { sortable: false, text: 'Group', value: 'group', align: 'center' },
          { sortable: false, text: 'Credit', value: 'credit', align: 'center' },
          { sortable: false, text: 'Invoice', value: 'invoice', align: 'center' },
          { sortable: true, text: 'Days Active', value: 'activedays', align: 'center' },
        ],
        icons: true,
        centered: true,
        newtab: null,
        activeBtn: 1,
        grow: true,
      }
    },
    computed: {
      getdaysactive () {
        this.loading = true
        let totalactivelist = []
        let credit = false
        let safetype = 'NA'

        let currentMonth = moment(Date.now()).format('MM')
        let allsites = this.$store.getters.loadedSites
        let montheods = this.$store.getters.getMonthEOD
        let alleods = []
        for (let day of montheods) {
          // loop thru the days and get the safes which had an EOD to do, some activity, put them all in the array
          alleods.push(Object.keys(day))
        }
        let list = []
        alleods.forEach(day => {
          let safeids = Object.values(day)
          safeids.forEach(safe => {
            list.push(safe)
          })
        })

        // get the unique values
        let uniquesafeids = [...new Set(list)]
        // count each time the unique values appear
        for (let safeid of uniquesafeids) {
          let count = list.filter(id => id === safeid)
          let name = 'Unknown'
          let group = 'Unknown'
          let created = 'unknown'
          let details = this.locations.find(id => id.safeid === safeid)
          console.log('details ', details)
          if (details) {
            name = details.idnum
            group = details.group
            created = moment(details.created_date).format('YYYY-MM-DD')
          }
          if (safeid.includes('Virtual')) {
            safetype = 'Virtual/Post'
          } else {
            safetype = 'Physical'
          }
          let rec = {
            sitename: name,
            safeid: safeid,
            group: group,
            created: created,
            safetype: safetype,
            credit: 'NA',
            activedays: count.length
          }
          totalactivelist.push(rec)
        }
        // create object of site name, safe id, number of days it appears
        //
        this.$log.debug('our list  ', totalactivelist)
        this.loading = false
        this.reload = false
        return totalactivelist
      }
    },
    watch: {
      loading (val) {
        if (!val) return

        setTimeout(() => (this.loading = false), 4000)
      }
    },
    created () {
      this.loading = true
      this.getloctions()
      this.$store.dispatch('loadunits')
      let rec = {
        month: moment().month(),
        year: moment().year()
      }
      this.$store.dispatch('loadmonthEOD', rec)
    },
    beforeDestroy () {
    },
    methods: {
      async generatepdf (item) {
        let sitename = item.sitename
        let invoicetime = 'na'
        invoicetime = moment(this.date).format('YYYY-MM')
        let sitedetails = this.$store.getters.loadedSites.find(location => sitename === location.idnum)
        let logob64
        let data = {
          // "documentTitle": "RECEIPT", //Defaults to INVOICE
          'currency': 'USD',
          'taxNotation': 'vat', // or gst
          'marginTop': 25,
          'marginRight': 25,
          'marginLeft': 25,
          'marginBottom': 25,
          'sender': {
            'company': 'Paythings',
            'address': 'Narva Mnt 7',
            'zip': '10124',
            'city': 'Tallinn',
            'country': 'Estonia'
            // "custom1": "custom value 1",
            // "custom2": "custom value 2",
            // "custom3": "custom value 3"
          },
          'client': {
            'company': sitename,
            'address': sitedetails.address,
            'zip': sitedetails.zipcode,
            'city': sitedetails.city,
            'country': sitedetails.state
            // "custom1": "custom value 1",
            // "custom2": "custom value 2",
            // "custom3": "custom value 3"
          },
          'invoiceNumber': '2020.0001',
          'invoiceDate': invoicetime,
          'products': [
            {
              'quantity': '1',
              'description': 'Smart Safe montly license fee',
              'tax': 0,
              'price': 20.00
            },
          ],
          'bottomNotice': 'Kindly pay your invoice within 15 days.'
        }
        const doc = new jsPDF()
        // let generaliLogo = base64Img.base64Sync('/img/generali_logo.png')
        // let contents = await imageToBase64('/img/generali_logo.png') // Image URL
        let paythings_logo = await imageToBase64('img/Paythings_blue_grey_final2.png') // Image URL
        // doc.addImage(contents, 'PNG', 15, 10, 45, 7)
        doc.addImage(paythings_logo, 'PNG', 145, 5, 60, 40)
        let client = {
          'company': sitename,
          'address': sitedetails.address,
          'zip': sitedetails.zipcode,
          'city': sitedetails.city,
          'country': sitedetails.state
          // "custom1": "custom value 1",
          // "custom2": "custom value 2",
          // "custom3": "custom value 3"
        }
        let pt_address = {
          name: 'Paythings Inc',
          address: 'PO Box 1463 Bayville',
          state: 'NY',
          zip: '11079',
          phone: '5169218900'
        }
        doc.setFontSize(12)
        doc.text('Client: ' + sitename, 15, 15)
        doc.text('Address: ' + sitedetails.address, 15, 25)
        doc.text('City: ' + sitedetails.city, 15, 35)
        doc.text('Zip: ' + sitedetails.zipcode, 15, 45)
        // doc.text('Blanket.com', doc.internal.pageSize.getWidth() / 2, 20, { align: 'center' })
        // doc.text('Generali Travel Policy', doc.internal.pageSize.getWidth() / 2, 30, { align: 'center' })
        let covRecs = []
        covRecs.push({})
        let servRecs = []
        autoTable(doc, {
          startY: 60,
          headStyles: {
            fillColor: [0, 0, 0],
          },
          head: [['Site Name', 'Type', 'Base Rate', 'Credit Fees', 'Total']],
          body: covRecs,
          theme: 'striped',
        })
        // let imgBase64 = jrQrcode.getQrBase64(item.tracking_number)
        // doc.addImage(imgBase64, 'JPEG', 110, 70, 75, 75)

        doc.save('item.policyNum' + '_invoice.pdf')
      },
      csvfilename () {
        let today = moment().format('YYYY-MM-DD')
        let filename = 'allsites' + 'billing' + '.csv'
        this.$log.debug('file name ', filename)
        return filename
      },
      csvdata () {
        let data = []
        return data
      },
      setmonth () {
        this.reload = true
        let usertime = moment(this.date, 'YYYY-MM')
        let rec = {
          month: usertime.month(),
          year: usertime.year()
        }
        this.$store.dispatch('loadmonthEOD', rec)
        this.month = usertime.format('MMMM')
        this.daysinmonth = usertime.daysInMonth()
      },
      getloctions () {
        let locations = []
        for (let [key, value] of Object.entries(this.$store.getters.loadedSiteProfiles)) {
          let safeid = 'Not Assigned'
          if (value.siteunitsprofile) {
            safeid = value.siteunitsprofile[0].crypto_idnum
            Object.assign(value, { safeid: safeid })
          }
          locations.push(value)
        }
        this.locations = locations
      },
      getsitelabel (ssid) {
        // return ssid
        let label = 'unknown'
        // get list of sites in the system
        this.$store.getters.loadedSites.filter(function (site) {
          if (site.idnum === ssid) {
            label = site.sitename
          }
        })
        return label
        // loop thru, find name
        // return sitename
      },
      complete (index) {
        this.list[index] = !this.list[index]
      }
    }
  }
</script>
